export enum LimitTrackingPeriod {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}

interface ProductFlags {
  hasProductAI: boolean // AI
  hasProductFF: boolean // FailureFlags
  hasProductFI: boolean // FaultInjection
  hasProductRM: boolean // ReliabilityManagement
}

interface Limits {
  limitAgents: number // aka clients limit
  limitServices: number
  limitTargets: number
  limitTeams: number
  limitUsers: number
}

export interface CompanyEntitlementResponse {
  company_id: string
  created_at: string // date string
  end: string // date string
  internal: boolean
  strict: boolean
  has_agent_billing: boolean // when has_agent_billing is false, billing type based off of attack targets
  has_trial_banners: boolean
  product_flags: ProductFlags
  limits: Limits
  targets_tracking_period: LimitTrackingPeriod
  updated_at?: string // date string
}

// these types are derived from the above types
export interface EntitlementsFlat extends Limits, ProductFlags {
  companyId: string
  dateStart: string
  dateEnd: string
  dateUpdated: string
  isStrict: boolean
  isInternal: boolean
  hasAgentBilling: boolean
  hasTrialBanners: boolean
  targetsTrackingPeriod: LimitTrackingPeriod
}
